export default "__VITE_ASSET__DbLhvka0__"